
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/preview/tech-services/[slug]",
      function () {
        return require("private-next-pages/preview/tech-services/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/preview/tech-services/[slug]"])
      });
    }
  